// extracted by mini-css-extract-plugin
export default {"file-creation-limit-alert":"style_file-creation-limit-alert__QG9NI","file-creation-limit-alert-content":"style_file-creation-limit-alert-content__6ZIvw"};